var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3AB5E8;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,13.9h7.8V2c0,0,0-0.1-0.1-0.1C37.3-0.8,26.7,3.7,26.7,20.4v8.4c0,0.1,0,0.2-0.2,0.2H15.1v13.5h11.4 c0.1,0,0.2,0,0.2,0.2v29.4h14.1V42.7c0-0.1,0-0.2,0.2-0.2h11.3l0,0L53.9,29H41c-0.1,0-0.2,0-0.2-0.2v-8.4c0-4.6,1.8-6.4,5.8-6.4 L46.7,13.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ec3abcd63f4aa830e7ae5b2d5298dfb0.svg";
export { ForwardRef as ReactComponent };